module.exports = __webpack_public_path__ + "static/5-5db48b156c8f100f90a17066d88f0887.jpg";